import {useFloatingSelectContext, useSelectContext} from '../../context'
import {SelectItemLayout} from '../select_item_layout'

export const SelectGroup = ({item}) => {
	const {label, items, originalIndex} = item
	const {updateValue, groupProps, multiple, getSelectedItems, expandedGroups, toggleGroupExpansion, readOnly} = useSelectContext()
	const {activeIndex, getItemProps} = useFloatingSelectContext()
	const {groupSelectable, collapsable = true} = groupProps || {}

	const isExpanded = expandedGroups.has(label)

	const selectable = multiple && groupSelectable
	const selectedValues = getSelectedItems(items)
	const isAllSelected = selectedValues.length === items.length
	const isPartiallySelected = selectedValues.length > 0 && !isAllSelected

	const active = activeIndex === originalIndex

	const handleCheckboxChange = () => {
		if (selectable) {
			updateValue(items)
		}
	}

	const handleClick = () => {
		collapsable ? toggleGroupExpansion(label) : handleCheckboxChange()
	}
	const itemProps = getItemProps({onClick: handleClick})

	return (
		<SelectItemLayout
			originalIndex={selectable && originalIndex}
			background={!collapsable && 'light-grey'}
			bold
			active={active}
			countSuffix={selectedValues.length}
			showChevron={collapsable}
			isExpanded={isExpanded}
			checkboxProps={
				selectable && {
					indeterminate: isPartiallySelected,
					checked: isAllSelected,
					...(collapsable &&
						!readOnly && {
							onChange: handleCheckboxChange,
						}),
				}
			}
			{...itemProps}
		>
			{label}
		</SelectItemLayout>
	)
}
